<form [formGroup]="form">
  <vs-form-field [config]="{ label: 'Name on card' }" appearance="vertical" class="mb-4">
    <input
      #nameInput
      vsInput
      [required]="true"
      type="text"
      placeholder="Full name on card"
      formControlName="name"
      (blur)="touched$.next()"
      (change)="nameInput.setCustomValidity(form.controls.name.valid ? '' : 'invalid')"
    />

    <p *ngIf="form.controls.name.invalid && form.controls.name.touched" slot="hint" class="text-danger">
      Required - Please provide the cardholder's name
    </p>
  </vs-form-field>

  <vs-form-field appearance="vertical">
    <label for="card_number" class="flex items-center justify-between">
      Card information

      <button *ngIf="isDevOrSandbox" vs-button size="sm" appearance="clear" (click)="useTestCard()">
        Use test card
      </button>
    </label>

    <vs-input-group formGroupName="card">
      <div class="w-full">
        <vs-input-container class="!rounded-tl-md !rounded-tr-md !rounded-bl-none !rounded-br-none">
          <vs-icon slot="start" name="credit-card-02"></vs-icon>
          <input
            id="card_number"
            #cardNumberInput
            [required]="true"
            type="text"
            formControlName="number"
            [mask]="cardMask$ | async"
            [validation]="false"
            placeholder="1234 1234 1234 1234"
            (blur)="touched$.next()"
            (change)="cardNumberInput.setCustomValidity(form.controls.card.controls.number.valid ? '' : 'invalid')"
          />
        </vs-input-container>

        <div class="flex">
          <input
            #cardExpirationInput
            vsInput
            [required]="true"
            type="text"
            mask="00 / 00"
            placeholder="MM/YY"
            formControlName="expiration"
            class="!m-0 !-mt-px !rounded-tl-none !rounded-tr-none !rounded-bl-md !rounded-br-none"
            (blur)="touched$.next()"
            (change)="
              cardExpirationInput.setCustomValidity(form.controls.card.controls.expiration.valid ? '' : 'invalid')
            "
          />

          <input
            #cardCVCInput
            vsInput
            [required]="true"
            type="text"
            mask="0009"
            placeholder="CVC"
            formControlName="cvc"
            class="!m-0 !-mt-px !-ml-px !rounded-tl-none !rounded-tr-none !rounded-bl-none !rounded-br-md"
            (blur)="touched$.next()"
            (change)="cardCVCInput.setCustomValidity(form.controls.card.controls.cvc.valid ? '' : 'invalid')"
          />
        </div>
      </div>
    </vs-input-group>
  </vs-form-field>
</form>
